/**
 * CostType Service
 * Register Angular Services for all things Cost Type (displaying cost_items)
 *
 * @package:  Betta
 * @version:  2.1
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('CostType', ['$resource', function($resource){
    return $resource('/api/v3/costType/:id', null, {
        'update': { method:'PUT' }
    });
}]);
